module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-121.8f11324e.jpg";